

















































import { Component, Prop } from 'vue-property-decorator';
import Vue from 'vue';
import { getModule } from 'vuex-module-decorators';
import CardTitle from '@/components/common/CardTitle.vue';
import AppSelector from '@/components/apps/AppsSelector.vue';
import AppNavTree from '@/components/apps/AppsNavTree.vue';
import Decision from '@/store/modules/Decisions';
import Apps from '@/store/modules/Apps';
import WorkspaceOptions from '@/store/modules/WorkspaceOptions'
import { v4 as uuidv4 } from 'uuid';

const decisionModule = getModule(Decision);
const appsModule = getModule(Apps);
const workspaceOptionsModule = getModule(WorkspaceOptions);

@Component({
    components: { CardTitle, AppSelector, AppNavTree },
})
export default class AddToApps extends Vue {
    private loading = false;
    private show = false;
    private name: string = '';

    @Prop({ default: '', type: String })
    title!: string;

    get decisionId() {
        return decisionModule.selectedDecisionId;
    }

    get apps() {
        return appsModule.apps;
    }

    get appId() {
        return appsModule.selectedAppId;
    }

    get activeAppMenuId() {
        return appsModule.activeAppMenuId;
    }

    get selectedApp() {
        return appsModule.appsDictionary[this.appId];
    }
    
    get currentUrl(){
        return workspaceOptionsModule.currentUrl;
    }

    private cancel() {
        this.show = false;
    }

    private addNewMenu() {
            const child = {
                id:uuidv4(),
                description: '',
                name: this.name,
                href: this.currentUrl.path + this.currentUrl.params,
            };
            if(this.activeAppMenuId){
                let appMenu = this.findAppMenuById(this.selectedApp,this.activeAppMenuId);
                if (appMenu){
                    if(!appMenu.children){
                        appMenu.children = [];
                    }
                    appMenu.children.push(child);
                }else{
                    this.selectedApp.children.push(child);
                }
            }else{
                this.selectedApp.children.push(child);
            }
            appsModule.updateApps({
                decisionId: this.decisionId,
                appId: this.appId,
                app: this.selectedApp,
            });
            this.name = '';
    }

    private findAppMenuById(app, appMenuId){
        if(app){
            if (app.id === appMenuId) {
                return app;
            }
            if (app.children && app.children.length > 0) {
                for (let child of app.children) {
                    let found = this.findAppMenuById(child,appMenuId);
                    if(found){
                        return found;
                    }
                }
            }
        }
        return null;
    }
}
